import React from "react";

import { PlusOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Skeleton } from "antd";
import "./role_list_skeleton.less";

const RoleListSkeleton: React.FC = () => {
  return (
    <div className="role-list-skeleton">
      <div className="role-list-left">
        <Skeleton.Input className="skeleton-line1" active size="small" />
        <Skeleton.Input className="skeleton-line2" active size="small" />
        <div className="user-info">
          <Avatar size={16} icon={<UserOutlined />} className="user-avatar" />
          <Skeleton.Input className="user-skeleton" active size="small" />
        </div>
      </div>

      <div className="role-list-right">
        <Avatar size={32} icon={<PlusOutlined />} className="plus-avatar" />
      </div>
    </div>
  );
};

export default RoleListSkeleton;
